<template>
  <div>
    <PageTitle icon="fa fa-industry" main="Projetos" />
    <b-row>
      <b-col lg="12">
        <b-card>
          <b-row>
            <b-col lg="8">
              <b-input-group class="mt-1 mb-2">
                <b-form-input size="sm" v-model="search" type="text"></b-form-input>
                <b-input-group-append>
                  <b-button size="sm" @click="getData" variant="info">
                    <i class="fas fa-search"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col lg="4">
              <b-button v-if="permiteEdicao" size="sm" @click="newRecord()" class="mt-1" style="float:right" variant="success">
                <i class="fas fa-plus"></i> Novo
              </b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="12">
              <b-table
                id="tbl"
                hover
                bordered
                resposive
                small
                striped
                head-variant="dark"
                primary-key="projeto_id"
                selectable
                select-mode="single"
                selected-variant="primary"
                show-empty
                empty-text="Sem dados para exibir"
                :per-page="pagination.perPage"
                :current-page="pagination.currentPage"
                :filter="search"
                :items="projects"
                :fields="fields"
                :busy="isBusy"
              >
                <template v-slot:table-busy>
                  <div class="text-center my-2">
                    <b-spinner class="align-middle mr-1"></b-spinner>
                    <strong>Carregando...</strong>
                  </div>
                </template>
                <template v-slot:cell(dt_inicio)="data">{{ data.item.dt_inicio | date('DD/MM/YYYY') }}</template>
                <template v-slot:cell(actions)="data">
                  <b-button v-if="permiteEdicao" size="sm" variant="success" @click="editRecord(data.item)">
                    <i class="fas fa-edit"></i>
                  </b-button>
                  <b-button v-if="permiteExclusao" size="sm" variant="danger" @click="deleteRecord(data.item)">
                    <i class="fas fa-trash"></i>
                  </b-button>
                  <b-button size="sm" variant="secondary" @click="viewRecord(data.item)">
                    <i class="fas fa-search"></i>
                  </b-button>
                </template>
              </b-table>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2">
              <b-form-group
                label="Exibir"
                label-cols-lg="4"
                label-for="pageSize"
                label-size="sm"
              >              
                <b-form-select size="sm" id="pageSize" v-model="pagination.perPage">
                  <b-form-select-option :value="8">8</b-form-select-option>
                  <b-form-select-option :value="20">20</b-form-select-option>
                  <b-form-select-option :value="50">50</b-form-select-option>
                  <b-form-select-option :value="0">Tudo</b-form-select-option>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col lg="10">
              <b-pagination
                class="float-right"
                v-model="pagination.currentPage"
                :total-rows="pagination.totalRows"
                :per-page="pagination.perPage"
                aria-controls="tbl"
              ></b-pagination>              
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <!-- MODAL -->
    <ModalProject :project="curRecord" :action="curAction" @inserted="onInserted" @updated="onUpdated" />
  </div>
</template>

<script>
import PageTitle from "@/components/layout/PageTitle"
import { baseApiUrl, formatDate, showError } from "@/global"
import axios from "axios"
import ModalProject from './ModalProject'
import { mapState } from "vuex"

export default {
  name: "Projects",
  components: { PageTitle, ModalProject },
  computed: {
    ...mapState["user"],
    permiteEdicao: function() {
      let _perfilID = this.$store.state.user.user.perfil_id
      return (_perfilID <= 5)
    },
    permiteExclusao: function() {
      let _perfilID = this.$store.state.user.user.perfil_id
      return (_perfilID < 2)
    }
  },
  data: function() {
    return {
      pagination:{
        perPage: 8,
        totalRows: 0,
        currentPage: 1
      },
      search: '',
      isBusy: false,
      curAction: "view",
      projects: [],
      curRecord: {},
      fields: [
        { key: "unidade_id", label: "UN", sortable: true },
        /*{ key: "titulo", label: "Título", sortable: true },*/
        { key: "empresa", label: "Projeto", sortable: true },
        { key: "cliente.razao_social", label: "Cliente", sortable: true },
        { key: "dt_inicio", label: "Data de Início", sortable: true },
        { key: "nr_contrato", label: "Nº Contrato", sortable: true },
        { key: "actions", label: "Ações" }
      ],
    };
  },
  methods: {
    onUpdated(){
      this.curAction = 'view'
      this.curRecord = {}
      this.getData()
    },
    onInserted(project){
      this.curAction = 'edit'
      this.curRecord.projeto_id = project.projeto_id
      this.getData()
    },    
    editRecord(item) {
      this.curAction = "edit"
      this.curRecord = { ...item }
      this.curRecord.dt_inicio = formatDate(this.curRecord.dt_inicio, "YYYY-MM-DD" ,"DD/MM/YYYY")
      this.$bvModal.show("modal-project")
    },
    viewRecord(item) {
      this.curAction = "view"
      this.curRecord = { ...item }
      this.curRecord.dt_inicio = formatDate(this.curRecord.dt_inicio,"YYYY-MM-DD","DD/MM/YYYY")
      this.$bvModal.show("modal-project")
    },
    newRecord() {
      this.curAction = "new";
      this.curRecord = {
        projeto_id: 0,
        dt_inicio: formatDate(new Date(), "", "DD/MM/YYYY")
      };
      this.$bvModal.show("modal-project");
    },
    // loadUsers(){
    //   axios.get(`${baseApiUrl}/usuarios`).then(
    //     res => this.combos.users = res.data
    //   )
    // },
    saveRecord() {},
    deleteRecord(item) {
      this.$bvModal
        .msgBoxConfirm(`Excluir o Projeto ${item.projeto_id}?`, {
          noFade: true
        })
        .then(
          (yesno) => {
            if(yesno){
              this.isBusy = true
              axios.delete(`${baseApiUrl}/projetos/${item.projeto_id}`, )
                .then(
                  () => this.getData()
                )
                .catch((err) => {
                  this.isBusy = false
                  showError(err)
                })
            }
          }
        )
        .catch(err => {
          this.isBusy = false
          console.log(err);
        });
    },
    getData() {
      this.isBusy = true
      let url = `${baseApiUrl}/projetos`;
      axios.get(url)
        .then( (resp) =>
          { 
            this.isBusy = false
            this.projects = resp.data
            this.pagination.totalRows = this.projects.length
          }
        ).catch(
          (err) => {
            this.isBusy = false
            showError(err)
        })
    },
    colWidths(field) {
      let _width = "180px";

      if (field.key === "actions") _width = "130px";
      else if (field.key === "projeto_id") _width = "80px";

      return { width: _width };
    },
  },
  mounted() {
    // se cliente oculta a coluna unidade
    if(this.$store.state.user.user.perfil_id == 6){
      this.fields = [
        { key: "empresa", label: "Projeto", sortable: true },
        { key: "cliente.razao_social", label: "Cliente", sortable: true },
        { key: "dt_inicio", label: "Data de Início", sortable: true },
        { key: "nr_contrato", label: "Nº Contrato", sortable: true },
        { key: "actions", label: "Ações" }
      ]
    }

    this.getData()
  }
};
</script>

<style>
.logo-project {
  max-height: 32px;
  width: auto;
}

.project-modal-title {
  display: flex;
  align-items: center;
  justify-content: center;
}

.project-modal-title h5 {
  margin-bottom: 0px;
  margin-left: 10px;
}

.project-modal-title img {
  max-height: 30px;
}

</style>